import { V3GroundPositionGroupsDataSourceService } from './../../../core/data-sources/v3/ground-position-groups/ground-position-groups-data-source.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Level } from '../stock-levels-modal.component';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { GroundPositionType } from 'src/app/pages/warehouse-map/warehouse-map-table/warehouse-map-table.component';
import { GroundGroupPosition } from 'src/app/core/data-sources/ground-position-group-data-source.service';
import { ActionService } from 'src/app/core/services/action.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';

const filter = (opt: any[], value: string): string[] => {
  const filterValue = value.toLowerCase();
  return opt.filter(item => item.name.toLowerCase().includes(filterValue));
};

interface GroundGroupList {
  type: string;
  options: { name: string; id: string; }[];
}


@Component({
  selector: 'app-level-details',
  templateUrl: './level-details.component.html',
  styleUrls: ['./level-details.component.scss']
})
export class LevelDetailsComponent implements OnInit {
  @Input() level: Level;
  @Input() position: GroundGroupPosition;
  @Output() closeModal = new EventEmitter();
  typeFormControl = new FormControl(null);
  groupFormControl = new FormControl(null);
  typesList: GroundPositionType[] = [];
  groundList: GroundGroupList[] = [];
  groundOptions: Observable<any>;
  filteredTypes: Observable<string[]>;

  constructor(
    private V3GroundPositionGroupsService: V3GroundPositionGroupsDataSourceService,
    private actionService: ActionService,
    private errorService: ErrorService
  ) { }

  async ngOnInit() {
    this.typesList = Object.values(GroundPositionType);
    const groups = await this.V3GroundPositionGroupsService.getAll().toPromise();
    const currentGroup = this.findGroupById(groups, this.level?.groundPositionGroupId);
    this.getGroupOptions(groups);
    this.groupFormControl.setValue(currentGroup);
    this.typeFormControl.setValue(this.level?.type);

    this.groundOptions = this.groupFormControl.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(''),
      map(value => typeof value === 'string' ? value : value.name),
      map(value => this.filterGroup(value))
    );

    this.filteredTypes = this.typeFormControl.valueChanges.pipe(
      distinctUntilChanged(),
      startWith(''),
      map(value => this.filterType(value))
    );
  }

  getGroupOptions(groups) {
    const groupedOptions = {};
    groups.forEach(group => {
      if (!groupedOptions[group.type]) {
        groupedOptions[group.type] = [];
      }

      groupedOptions[group.type].push({
        id: group.id,
        name: group.name
      })
    });

    for (const name in groupedOptions) {
      this.groundList.push({
        type: name,
        options: groupedOptions[name]
      });
    }

    this.groundList.sort((a, b) => a.type.localeCompare(b.type));
    this.groundList.forEach(group => {
      group.options.sort((a, b) => a.name.localeCompare(b.name));
    });
  }

  filterGroup(value: string) {
    if (value) {
      return this.groundList.map(group => ({ type: group.type, options: filter(group.options, value) }))
        .filter(group => group.options.length > 0);
    }

    return this.groundList;
  }

  filterType(value: string) {
    return this.typesList.filter(item => item.toLowerCase().includes(value));
  }

  close() {
    this.closeModal.emit(true);
  }

  async applyChanges() {
    try {
      await this.editType();
      await this.editGroup();
    } catch (e) {
      switch (e.error.body.type) {
        case ErrorsEnum.GROUND_POSITION_ERROR_CONFLICT_TYPE:
          const errorMsg = "O tipo da posição não é compatível com o tipo do setor.";
          this.errorService.openErrorSnackBarWithCustomMessage(errorMsg);
          break;
        default:
          this.errorService.openErrorSnackBar(e);
          break;
      }
    } finally {
      this.closeModal.emit(true);
    }
  }

  async editGroup() {
    if (this.groupFormControl.value?.id?.length) {
      const editPositionGroupData = {
        groupId: this.groupFormControl.value.id,
        id: this.level.id
      };
      await this.actionService.editPositionGroup(editPositionGroupData);
    }
  }

  async editType() {
    if (this.typeFormControl.value?.length) {
      const editPositionTypeData = {
        type: this.typeFormControl.value,
        id: this.level.id
      };
      await this.actionService.editPositionType(editPositionTypeData);
    }
  }

  findGroupById(groups, id) {
    return groups.find(option => option.id === id);
  }

  displayGroupNameFn(group) {
    return group ? group.name : '';
  }
}
